import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Text } from './styled';

const IconButton = ({
  onClick, title, icon, text, disabled
}) => (
  <Wrapper title={ title } onClick={ onClick } disabled={ disabled }>
    {icon}
    { text && <Text>{ text }</Text> }
  </Wrapper>
);

IconButton.defaultProps = {
  onClick: null,
  disabled: false
};

IconButton.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default IconButton;
